import { connect } from 'react-redux';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { SpaEntityFormSteps } from '@common/components/SpaEntity/SpaEntityFormSteps';
import { Routes } from '@common/constants';
import { EntityTypes } from '@common-types/Entities';
import { SpaTreatmentFormStepEnum } from './SpaTreatment.types';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  showGenderNeutral: entitySelectors.isSpaShowGenderNeutralEnabled(state),
  SpaEntityFormStepEnum: SpaTreatmentFormStepEnum,
  entityBookingRoute: Routes.SPA_TREATMENT_BOOKING,
  entityType: EntityTypes.TREATMENT,
  entityLabel: 'spa.spaTreatment',
});

export const SpaTreatmentFormStepsContainer: any = connect(mapStateToProps)(
  SpaEntityFormSteps as any
);
